import { render, staticRenderFns } from "./IsoDate.vue?vue&type=template&id=c36b3440&"
import script from "./IsoDate.vue?vue&type=script&lang=js&"
export * from "./IsoDate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports